import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const regionGroups = "api/regionGroups";

const list = (params: {}) => {
    return request(`${regionGroups}/getListForSelect${containsQuery(params)}`, { method: "GET" });
};

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter } });

    return request(`${regionGroups}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const apply = (params: {}) => {
    return alertRequest(`${regionGroups}/apply`, body(params));
};

const getItem = ({ id }: { id: string }) => {
    return request(`${regionGroups}/get/${id}`, { method: "GET" });
};

const delItem = (params: {}) => {
    return alertRequest(`${regionGroups}/delete`, body(params));
};

export { list, apply, index, getItem, delItem };
